import react from "react";

import btb1 from "../images/commercials/BehindTheBank/MMAGAZINENEW_001 Large.jpeg";
import btb2 from "../images/commercials/BehindTheBank/MMAGAZINENEW_002 Large.jpeg";
import btb3 from "../images/commercials/BehindTheBank/MMAGAZINENEW_003 Large.jpeg";
import btb4 from "../images/commercials/BehindTheBank/MMAGAZINENEW_004 Large.jpeg";
import btb5 from "../images/commercials/BehindTheBank/MMAGAZINENEW_005 Large.jpeg";

const BehindTB = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={btb1} alt="M Magazine - Behind The Bank - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={btb2} alt="M Magazine - Behind The Bank - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={btb3} alt="M Magazine - Behind The Bank - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={btb4} alt="M Magazine - Behind The Bank - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={btb5} alt="M Magazine - Behind The Bank - Image 5"/>
                </div>
            </div>
        </div>
    );
}

export default BehindTB;